// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3596":"subscription","3715":"list","7962":"home","9702":"story"}[chunkId] || chunkId) + "-" + {"3596":"eb2319e32441d9bbc761","3715":"91841aa6e51f1231fcd4","7539":"239b3113388310ad8fda","7962":"5da89bb7f1afa3c17010","9702":"2f91af26d21db821313f"}[chunkId] + ".css";
};